import React from 'react';

import LeftBackGroundPattern from '@job-facets/Icons/leftBackgroundPattern';
import RightBackgroundPattern from '@job-facets/Icons/rightBackgroundPattern';
import PopularTags from '@job-facets/components/header-hero/popular-tags/Module';
import GroupedForm from '@job-facets/components/header-hero/form-group/Module';
import { useGetJobsFacetsQuery } from '@job-facets/redux/fetchApiSlice';
import HeaderSkeleton from './skeletonView';

import { __ } from '@wordpress/i18n';

function HeaderHeroLayout() {
	const { data } = useGetJobsFacetsQuery();

	if(typeof data === 'undefined') {
		return <HeaderSkeleton />
	}

	return (
		<div className='boxed-1600 ss-section header-hero'>
			<div className='container header-hero__root-content'>
				<h2 className='h2-bigger header-hero__form-title'>
					{__('Find the right fit.', 'job')}
				</h2>
				<GroupedForm />
				<PopularTags />
			</div>
			<div className='header-hero__left-background-pattern'>
				<LeftBackGroundPattern />
			</div>
			<div className='header-hero__right-background-pattern'>
				<RightBackgroundPattern />
			</div>
		</div>
	);
}

export default HeaderHeroLayout;
